"use client"

import { useDeviceResize } from "@/hooks/app/useDeviceResize"

const DeviceResizer = () => {
  useDeviceResize()
  
  return <></>
}

export default DeviceResizer